import CarlineSelection from './CarlineSelection'
import carlineSelectionContainer from './carlineSelectionContainer'

export default carlineSelectionContainer(CarlineSelection)
